import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {VeranstaltungMainPage} from './veranstaltung-main.page';
import {VeranstaltungMainPageUiEffects} from './veranstaltung-main.effects.ui';
import {EffectsModule} from '@ngrx/effects';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {StoreModule} from '@ngrx/store';
import {reducers} from './veranstaltung-main.reducer';
import {VeranstaltungMainPageWsEffects} from './veranstaltung-main.effects.ws';

const routes: Routes = [
    {
        path: '',
        component: VeranstaltungMainPage,
        children:
            [
                {
                    path: 'info',
                    loadChildren:  () => import( '../veranstaltung-info/veranstaltung-info.module').then(m => m.VeranstaltungInfoModule)
                },
                {
                    path: 'mitteilungen',
                    loadChildren:  () => import( '../mitteilungen/mitteilungen.module').then(m => m.MitteilungenPageModule)
                },
                {
                    path: 'checklisten',
                    loadChildren:  () => import( '../checklisten-aufgaben/checklisten-aufgaben.module').then(m => m.ChecklistenAufgabenPageModule)
                }/*,
                {
                    path: 'incident-abteilungsleitstelle',
                    loadChildren: () => import( '../incident-abteilungsleitstelle/incident-abteilungsleitstelle.module').then(m => m.IncidentAbteilungsleitstellePageModule),
                },
                {
                    path: 'meine-aufgaben',
                    loadChildren: () => import( '../meine-aufgaben/meine-aufgaben.module').then(m => m.MeineAufgabenPageModule),
                }*/
            ]
    },
    /*{
        path: 'leitstelle-detail',
        children: [
            {
                path: ':incident_id',
                loadChildren: () => import( '../leitstelle-detail/leitstelle-detail.module').then(m => m.LeitstelleDetailPageModule),
            }
        ]
    }*/
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature('VeranstaltungMainPage', reducers),
        EffectsModule.forFeature([
            VeranstaltungMainPageUiEffects,
            VeranstaltungMainPageWsEffects
        ]),
        SopiComponentsModule,
    ],
    declarations: [VeranstaltungMainPage],
    providers: []
})
export class VeranstaltungMainModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: VeranstaltungMainModule
        };
    }
}
